import script from "./RushHourGame.vue?vue&type=script&setup=true&lang=js"
export * from "./RushHourGame.vue?vue&type=script&setup=true&lang=js"

import "./RushHourGame.vue?vue&type=style&index=0&id=8bc6236a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bc6236a"]])

export default __exports__